import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import { useRef } from "react";
import { Overline } from "./Reveal";
import { IMAGES } from "../../lib/site";

const LINES = [
  "Luxury isn't created by expensive furniture.",
  "It's created by how a space feels.",
  "The polished stone. The natural light.",
  "The spotless glass. The perfectly folded linen.",
  "The calm that welcomes you through the front door.",
];

export default function Difference() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const smooth = useSpring(scrollYProgress, { stiffness: 90, damping: 30, restDelta: 0.001 });
  const imgY = useTransform(smooth, [0, 1], ["-8%", "8%"]);

  return (
    <section ref={ref} className="relative">
      <div className="relative h-[130vh]">
        <div className="sticky top-0 h-screen overflow-hidden">
          <motion.div style={{ y: imgY }} className="absolute inset-0 scale-125 will-change-transform">
            <img src="/med-interior.png" alt="Inside a luxury Mediterranean home" className="h-full w-full object-cover" />
          </motion.div>
          <div className="absolute inset-0 bg-charcoal/45" />

          <div className="relative z-10 h-full max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col justify-center">
            <Overline className="text-antique-gold">Our Difference</Overline>
            <div className="mt-8 max-w-4xl">
              {LINES.map((line, i) => (
                <div key={i} className="reveal-mask">
                  <motion.p
                    initial={{ y: "110%" }}
                    whileInView={{ y: "0%" }}
                    viewport={{ once: true }}
                    transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 }}
                    className="font-serif font-light text-warm-white text-2xl sm:text-3xl md:text-4xl leading-[1.35]"
                  >
                    {line}
                  </motion.p>
                </div>
              ))}
              <motion.p
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1, delay: 0.9 }}
                className="mt-8 font-sans italic text-warm-white/80 text-lg"
              >
                {"That's the Casa Galênê experience."}
              </motion.p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
